<script>
import VuetifyColourClass from '@/constants/core/VuetifyColourClass'
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'FormSubmissionSkeleton',
  mixins: [baseMixin],
  computed: {
    compCardClasses() {
      return 'rounded-xl'
    },
    compCardColor() {
      return VuetifyColourClass.white
    },
    compSkeletonLoaderClasses() {
      return this.isEmbedded ? 'pa-0' : ''
    },
  },
}
</script>

<template>
  <v-card :class="compCardClasses" :color="compCardColor" :flat="isEmbedded">
    <v-card-title style="width: 65%" :class="[compSkeletonLoaderClasses]">
      <v-skeleton-loader
        :color="compCardColor"
        type="heading"
      ></v-skeleton-loader>
    </v-card-title>
    <v-card-subtitle>
      <v-skeleton-loader
        :color="compCardColor"
        type="sentences"
      ></v-skeleton-loader>
    </v-card-subtitle>

    <v-divider class="mb-4" />
    <v-card-text :class="[compSkeletonLoaderClasses]">
      <v-skeleton-loader
        :color="compCardColor"
        style="width: 40%"
        type="text"
      ></v-skeleton-loader>
      <v-text-field
        color="primary"
        loading
        readonly
        class="mx-4"
        density="compact"
      ></v-text-field>

      <v-skeleton-loader
        :color="compCardColor"
        type="sentences"
      ></v-skeleton-loader>

      <v-skeleton-loader
        :color="compCardColor"
        style="width: 35%"
        type="text"
      ></v-skeleton-loader>
      <v-text-field
        color="primary"
        loading
        readonly
        class="mx-4"
        density="compact"
      ></v-text-field>

      <v-skeleton-loader
        :color="compCardColor"
        style="width: 50%"
        type="text"
      ></v-skeleton-loader>
      <v-text-field
        color="primary"
        loading
        readonly
        class="mx-4"
        density="compact"
      ></v-text-field>

      <v-skeleton-loader
        :color="compCardColor"
        style="width: 44%"
        type="text"
      ></v-skeleton-loader>
      <v-text-field
        color="primary"
        loading
        readonly
        class="mx-4"
        density="compact"
      ></v-text-field>

      <v-skeleton-loader
        :color="compCardColor"
        type="list-item-avatar-two-line"
      ></v-skeleton-loader>

      <v-skeleton-loader
        :color="compCardColor"
        style="width: 44%"
        type="text"
      ></v-skeleton-loader>
      <v-text-field
        color="primary"
        loading
        readonly
        class="mx-4"
        density="compact"
      ></v-text-field>
    </v-card-text>
  </v-card>
</template>
